<template>
  <BasePopup v-if="isLoaded" closeType="stayOnPage" width="700" @clickToClose="clickToClose">
    <div>
        <header>
            <font-awesome-icon icon="fa-solid fa-puzzle-piece" style="color: #28bc6d;"/>
            <span class="ms-2 align-middle">{{ integration.title }}</span>
        </header>
        <div>
            <form @submit.prevent="" class="row">
                <template v-if="route.params.slug != 'notazz'">                 
                    <div v-for="(field, key) in integration.content" :class="field.class" :key="key">
                        <BaseInput
                            v-if="field.type == 'input'"
                            class="mb-3"
                            :label="field.title"
                            :id="'content.' + field.name"
                            :required="false"
                            v-model="field.value"
                            :page="route.name"
                        />
                        <BaseSelect
                            v-if="field.type == 'select'"
                            class="mb-3"
                            :label="field.title"
                            :items="field.items"
                            :id="'content.' + field.name"
                            :required="false"
                            v-model="field.value"
                            :page="route.name"
                        />
                        <BaseSwitch 
                            v-if="field.type == 'checkbox'" 
                            :label="field.title"
                            class="mb-3"
                            :id="'content.' + field.name"
                            v-model:checked="field.value"
                            :page="route.name"
                        />
                        
                    </div>
                </template>
                <div v-else>
                    <BaseInput
                        :class="integration.content[0].class + ' mb-3'"
                        :label="integration.content[0].title"
                        :id="'content.' +  integration.content[0].name"
                        :required="false"
                        v-model="integration.content[0].value"
                        :page="route.name"
                    />
                    <BaseSelect
                        :class="integration.content[1].class  + ' mb-3'"
                        :label="integration.content[1].title"
                        :items="integration.content[1].items"
                        :id="'content.' + integration.content[1].name"
                        :required="false"
                        v-model="integration.content[1].value"
                        :page="route.name"
                    />
                    <BaseInput
                        v-if="integration.content[1].value == 'nfs_e'"
                        :class="integration.content[2].class  + ' mb-3'"
                        :label="integration.content[2].title"
                        :id="'content.' +  integration.content[2].name"
                        :required="false"
                        v-model="integration.content[2].value"
                        :page="route.name"
                    />
                </div>
                <BaseSwitch id="ActivateSwitch" label="Ativar" class="mb-3" v-model:checked="integration.status"/>
                <div v-if="(integration.status == 0) && integration.type == 'payment' && initial_status == 1" class="col-12">
                    <div class="alert alert-warning" role="alert">Desativando essa integração, todas as formas de pagamento associadas a ela serão desabilitadas!</div>
                </div>

                <div class="col-12" v-if="integration.type == 'payment'">
                    <label>Url para recebimento de Webhooks</label>
                    <div class="code">
                        <code>{{ paymentUrl() }}<span
                            data-bs-toggle="tooltip"
                            data-bs-placement="right"
                            data-bs-animation="true"
                            v-tooltip
                            title="Copiar variável"
                            :data-copy='paymentUrl()'
                            @click="copy()"
                            ><font-awesome-icon icon="fas fa-copy"
                        /></span>
                        </code>
                    </div>
                </div>

                <div class="col-12">
                    <BaseButton @click="submit" class="btn-success w-100 mt-3">
                        Salvar
                    </BaseButton>
                </div>
            </form>
        </div>
    </div>
  </BasePopup>
</template>

<script setup>
import { computed, onBeforeMount, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useGlobalStore } from "@/stores/global";
import { useStoreStore } from "@/stores/store";
import { storeToRefs } from "pinia";

const route = useRoute();
const router = useRouter();
const globalStore = useGlobalStore();
const storeStore = useStoreStore();
const { integration, store } = storeToRefs(storeStore);

const isLoaded = ref(false);
const initial_status = integration.value.status;

const store_id = computed(function () {
  return route.params.id;
});

onBeforeMount(() => {
  delete globalStore.errors[route.name];
  if(storeStore.integration.id){
    isLoaded.value = true;
  } else {
    storeStore.tryIntegration(route.params.slug).then(() =>{
        isLoaded.value = true;
    })
  }
});

function paymentUrl() {
    return "https://checkout.yo.sale/postbacks/" + integration.value.slug + "/" + store.value.code;
}

function copy(){
    navigator.clipboard.writeText(paymentUrl());
}

let previousPage = router.options.history.state.back;

function clickToClose() {
    router.push(previousPage)
}

function submit() {
  globalStore.loader("show");
  let params = {
    content: {},
    status: storeStore.integration.status,
  };
  for (let i = 0; i < storeStore.integration.content.length; i++) {
    params.content[storeStore.integration.content[i].name] =
      storeStore.integration.content[i].value;
  }

  storeStore
    .tryUpdateIntegration(store_id.value, params, route.name)
    .then(function (success) {
      if (success) {
        storeStore.tryIntegrations().then(() => {
          globalStore.loader("hide");
          router.push("/stores/" + store_id.value + "/integrations");
        });
      } else {
        globalStore.loader("hide");
      }
    });

    if(route.params.slug === 'mautic'){
      window.open('//api-dash.yo.sale/postbacks/mautic/auth?id_store=' + store_id.value, '_blank')
    }
}
</script>

<style scoped>
.code {
    box-sizing: border-box;
    position: relative;
}

.code code {
    background: #f7f7f7;
    margin: 0;
    padding: 10px;
    display: block;
    border: 1px solid #d7d7d7;
    border-radius: 8px;
}

.code span {
    cursor: pointer;
    margin-left: 10px;
    padding-right: 5px;
    color: #28bc6d;
    vertical-align: middle;
}

.code span:hover {
    color: #767676;
}
</style>